import lf from 'lovefield'

export function const_godets (schemaBuilder) {
  schemaBuilder.createTable('const_godets')
      .addColumn('id', lf.Type.INTEGER)
      .addColumn('code', lf.Type.STRING)
      .addColumn('nom', lf.Type.STRING)
      .addColumn('const_engins_id', lf.Type.INTEGER)
      .addColumn('capacite', lf.Type.NUMBER)
      .addColumn('dents', lf.Type.INTEGER)
      .addColumn('solrocheux', lf.Type.INTEGER)
      .addPrimaryKey(['id']);
}

/*
CREATE TABLE IF NOT EXISTS `const-godets` (
  `id` int(11) NOT NULL AUTO_INCREMENT,
  `code` varchar(3) NOT NULL,
  `nom` varchar(20) NOT NULL,
  `const-engins_id` int(11) NOT NULL,
  `capacite` float NOT NULL,
  `dents` tinyint(4) NOT NULL,
  `solrocheux` tinyint(1) NOT NULL,
  PRIMARY KEY (`id`)
) ENGINE=InnoDB  DEFAULT CHARSET=utf8 AUTO_INCREMENT=7 ;
*/



// WEBPACK FOOTER //
// ./src/client/common/db/schemas/constGodets.schema.js